<template>
  <VAutocomplete
    v-model="select"
    :items="items"
    :loading="queryStatus"
    :search-input.sync="search"
    :filter="contactFilter"
    item-text="id"
    cache-items
    chips
    clearable
    label="Search for a contact"
    multiple
    @change="onItemsChange"
  >
    <template slot="no-data">
      <v-list-tile>
        <v-list-tile-title>
          <strong>Cannot find a contact</strong>
        </v-list-tile-title>
      </v-list-tile>
    </template>
    <template
      slot="selection"
      slot-scope="{ item, selected }"
    >
      <v-chip
        :selected="selected"
        close
        color="blue-grey"
        class="chip--select-multi white--text"
        @input="remove(item)"
      >
        <v-avatar>
          <img :src="item.avatarImg">
        </v-avatar>
        {{ item.fullName }}
      </v-chip>
    </template>
    <template
      slot="item"
      slot-scope="{ item }"
    >
      <template v-if="typeof item === 'object'">
        <v-list-tile-avatar
          color="indigo"
          class="headline font-weight-light white--text"
        >
          <v-avatar>
            <img :src="item.avatarImg">
          </v-avatar>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.fullName" />
          <v-list-tile-sub-title v-text="item.number" />
        </v-list-tile-content>
      </template>
    </template>
  </VAutocomplete>
</template>

<script>
import { NetworkStatus } from 'apollo-client/core/networkStatus'
import _ from 'lodash'
export default {
  name: 'ContactAutoComplete',
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultArraySelect: {
      type: Array,
      default: function () {
        return []
      }
    },
    getGqlQuery: {
      type: Object,
      default: function () {
        return null
      }
    },
    getQueryVariables: {
      type: Function,
      default: function () {
        return {}
      }
    },
    updateContextVariable: {
      type: Function,
      default: function (key, value) {
        if (this.hasOwnProperty(key)) {
          this[key] = value
        }
      }
    },
    getQueryStatus: {
      type: Function,
      default: function (val) {}
    },
    setQueryStatus: {
      type: Function,
      default: function (val) {}
    },
    parseData: {
      type: Function,
      default: function () {
        return {}
      }
    },
    clearAll: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      search: '',
      select: this.defaultArraySelect
    }
  },
  computed: {
    queryStatus: {
      get: function () {
        return this.getQueryStatus()
      },
      set: function (val) {
        this.setQueryStatus(val)
      }
    }
  },
  apollo: {
    getTableItems: {
      query () {
        return this.getGqlQuery
      },
      variables () {
        return this.getQueryVariables()
      },
      manual: true,
      result ({ data, loading, networkStatus }) {
        // console.log('run GQL')
        this.setNetworkStatus(networkStatus)
        if (!loading && networkStatus !== NetworkStatus.error) {
          this.parseData(data)
        }
      },
      error (error) {
        this.queryStatus = false
        this.$store.dispatch('alert/error', error.message)
      }
    }
  },
  watch: {
    search () {
      this.debouncedGetQuerySelect()
    }
  },
  created: function () {
    this.debouncedGetQuerySelect = _.debounce(this.querySelect, 300)
  },
  beforeDestroy () {
    this.clearAll()
  },
  methods: {
    querySelect () {
      if (!this.search) {
        this.updateContextVariable('queryString', '')
      } else {
        this.updateContextVariable('queryString', this.search)
      }
    },
    setNetworkStatus (networkStatus) {
      switch (networkStatus) {
        case NetworkStatus.loading:
          this.queryStatus = true
          // this.statusMessage = 'Loading contacts. Please wait...'
          break
        case NetworkStatus.setVariables:
          this.queryStatus = true
          // this.statusMessage = 'Loading contacts. Please wait...'
          break
        case NetworkStatus.ready:
          break
        case NetworkStatus.poll:
          break
        case NetworkStatus.error:
          this.queryStatus = false
          break
        default:
          break
      }
    },
    remove (item) {
      const index = this.select.indexOf(item.id)
      if (index >= 0) this.select.splice(index, 1)
    },
    contactFilter (item, queryText, itemText) {
      if (!item) return false
      return item.fullName.toLowerCase().includes(queryText.toLowerCase()) || item.number.includes(queryText)
    },
    onItemsChange (val) {
      this.search = null
    }
  }
}
</script>

<style scoped>

</style>
